import {
  ParticipantStateTypes,
  PullRequestParticipant,
  User,
} from 'src/components/types';
import { isReviewer, isNotAuthor } from 'src/utils/pull-request-roles';

export type PullRequest = Models.PullRequest<{
  author: User | null | undefined;
  participants: PullRequestParticipant[];
}>;

export default (pullRequest: PullRequest, currentUserUuid?: string | null) => {
  const { author, participants } = pullRequest;

  const reviewers = participants.filter(
    participant => isReviewer(participant) && isNotAuthor(participant, author)
  );
  const mergeBlockers = reviewers.filter(
    reviewer => reviewer.state === ParticipantStateTypes.changesRequested
  );
  const approvers = reviewers.filter(
    reviewer =>
      reviewer.approved || reviewer.state === ParticipantStateTypes.approved
  );
  const others = reviewers.filter(reviewer => !reviewer.state);

  if (currentUserUuid) {
    const isCurrentUser = (participant: BB.PullRequestParticipant) =>
      participant.user && participant.user.uuid === currentUserUuid;

    const sortCurrentUserFirst = (arr: BB.PullRequestParticipant[]) => {
      const currentUserIndex = arr.findIndex(isCurrentUser);
      if (!currentUserIndex) {
        return;
      }
      arr.sort((a, b) => {
        if (isCurrentUser(a)) {
          return -1;
        }
        if (isCurrentUser(b)) {
          return 1;
        }
        return 0;
      });
    };

    sortCurrentUserFirst(mergeBlockers);
    sortCurrentUserFirst(approvers);
    sortCurrentUserFirst(others);
  }
  return [...mergeBlockers, ...approvers, ...others];
};
